<!--
 * @Auther: qinzhenhao
 * @Date: 2022-12-27 18:41:20
 * @LastEditors: qinzhenhao
 * @LastEditTime: 2023-01-03 18:50:27
 * @Description: 
-->
<template>
    <div class="messageContainer" v-if="downloadMesShow">
        <div class="messageTip">
            <div class="imgBox">
                <img :src="computedImg" alt="" style="width: 100%;">
                <div 
                    class="closeIconBox" 
                    @click="closeBox()">
                    <img src="../assets/imgs/download_close.png" alt="" style="width: 100%;">
                </div>
            </div>
            <div class="btnBox">
                <div class="browserDownLoadBtn"
                @click="downLoadApp()">直接下载</div>
                <div :class="computedBtnClass" 
                @click="downLoadStore()">跳转应用商店</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Util from '../utils/index.js'
    import download_header from "../assets/imgs/download_header.png"
    import download_header_red from "../assets/imgs/download_header_red.png"
    import download_header_common from "../assets/imgs/download_header_common.png"
    const GREEN_DATA = ['xmxx','xmxxpad']//需要使用绿色的软件
    const RED_DATA = ['xmgj']//需要使用红色的软件
    export default {
        data (){
            return {
                
            }
        },
        computed:{
            ...mapState({
                downloadMesShow: 'downloadMesShow',
                downloadName: 'downloadName'
            }),
            computedImg(){
                if(GREEN_DATA.indexOf(this.downloadName) !== -1){
                    return download_header
                }else if(RED_DATA.indexOf(this.downloadName) !== -1){
                    return download_header_red
                }else{
                    return download_header_common //默认蓝色
                }
            },
            computedBtnClass(){
                if(GREEN_DATA.indexOf(this.downloadName) !== -1){
                    return 'storeDownLoadBtn'
                }else if(RED_DATA.indexOf(this.downloadName) !== -1){
                    return 'storeDownLoadBtnRed'
                }else{
                    return 'storeDownLoadBtnCom' //默认蓝色
                }
            }
        },
        methods:{
            closeBox() {
                //隐藏div
                this.$store.commit('CLOSE_MES'); //隐藏div
            },
            // APP下载
            downLoadApp(){
                Util.downLoadApp()
                this.closeBox()
            },
            downLoadStore(){
                Util.downLoadStore()
                this.closeBox()
            }
        }
    }
</script>
<style lang="scss" scoped>
.messageContainer {
                    z-index: 999;
                    width:100%;
                    height: 100vh;
                    position: fixed;
                    top: 0px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: rgba(0, 0, 0, .5);
                }
.closeIconBox {
    position: absolute;
    width: 40px;
    height:40px;
    top: 32%;
    right: 16px;
}
.messageTip {
    width: 80%;
    box-sizing: border-box;
    border-radius: 16px 16px 16px 16px;
    overflow: hidden;
}
.imgBox {
    width: 100%;
    position: relative;
}
.imgBox img {
    display: block;
}
.downTipBox {
    padding-top: 20px;
    text-align: center;
    margin-bottom: 20px;
        background: #FFFFFF;
}
.btnBox {
    width: 100%;
    height: 168px;
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    align-items: center;
}
.storeDownLoadBtn {
    width: 240px;
    height: 80px;
    background-color: #F0F0F0;
    border-radius: 56px 56px 56px 56px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(126deg, #46E3A1 0%, #3BBE93 100%);
    box-shadow: 0px 5px 10px 0px rgba(11,49,36,0.1);
    font-size: 32px;
}
.storeDownLoadBtnRed {
    width: 240px;
    height: 80px;
    background-color: #F0F0F0;
    border-radius: 56px 56px 56px 56px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(133deg, #FC6D3C 0%, #FF3510 100%);
    box-shadow: 0px 5px 10px 0px rgba(9,29,58,0.1);
    font-size: 32px;
}

.storeDownLoadBtnCom {
    width: 240px;
    height: 80px;
    background-color: #F0F0F0;
    border-radius: 56px 56px 56px 56px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(133deg, #31BCFF 0%, #327BFE 100%);;
    box-shadow: 0px 5px 10px 0px rgba(9,29,58,0.1);
    font-size: 32px;
}
.browserDownLoadBtn {
    width: 240px;
    height: 80px;
    background-color: #F0F0F0;
    border-radius: 56px 56px 56px 56px;
    color: #262626;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
}
</style>

